/* eslint-disable react/destructuring-assignment */
import { PortfolioInfoDetail } from 'clientportalshared';
import Grid from '@mui/material/Grid';
import { useHistory } from 'react-router-dom';
import { numberFormatterDollar } from '@utils/GenericUtils';
import { holdingsUrl } from '@utils/UrlBuilder';
import { Box, Card, CardContent, CardHeader, Tooltip, Typography } from '@mui/material';
import { useAppDispatch } from '@src/app/hooks/store';
import { selectOnePortfolioByKey } from '@src/app/store/reducers/portfolios';
import { BarChart, ChevronRight } from '@mui/icons-material';
import { useEffect, useRef, useState } from 'react';

const PortfolioCard = (props: PortfolioInfoDetail): JSX.Element => {
  const dispatch = useAppDispatch();
  const cardRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number>(0);

  const portfolioKey = props.portfolioKey!;
  const name = props.name!;
  const currentValue = props.currentValue || 0;

  const history = useHistory();

  const selectPortfolio = () => {
    dispatch(selectOnePortfolioByKey(portfolioKey));
  };

  const handleNavigation = () => {
    selectPortfolio();
    history.push(holdingsUrl());
  };

  useEffect(() => {
    if (cardRef.current) {
      setWidth(cardRef.current.offsetWidth);
    }
  }, [cardRef.current?.offsetWidth]);

  return (
    <Grid ref={cardRef} item xs={12} lg={6} xl={3} onClick={handleNavigation} sx={{ ':hover': { cursor: 'pointer' } }}>
      <Tooltip title={name}>
        <Card
          elevation={0}
          sx={{
            overflow: 'hidden',
            paddingTop: '20px',
            paddingRight: '16px',
            paddingLeft: '16px',
            paddingBottom: '20px',
            borderRadius: '24px',
            borderWidth: '1px',
            border: '1px solid #E9E9E9',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100%',
          }}
        >
          <CardHeader
            sx={{
              overflow: 'hidden',
            }}
            title={
              <Box display="flex" alignItems="center" sx={{ overflow: 'hidden', width: '100%', textOverflow: 'ellipsis' }}>
                <BarChart sx={{ color: '#222222', flexShrink: 0, mr: 1 }} />
                <Typography
                  fontSize={16}
                  color="#222222"
                  noWrap
                  sx={{
                    maxWidth: width ? `${Math.max(width - 120, 0)}px` : '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    flexGrow: 1,
                    minWidth: 0,
                  }}
                >
                  {name}
                </Typography>
              </Box>
            }
            action={<ChevronRight sx={{ color: '#222222', flexShrink: 0 }} />}
          />
          <CardContent>
            <Typography fontWeight={600} fontSize={28}>
              {numberFormatterDollar(currentValue)}
            </Typography>
          </CardContent>
        </Card>
      </Tooltip>
    </Grid>
  );
};

export default PortfolioCard;
